import React from 'react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function PainStory() {
  const {
    t
  } = useLanguage();
  return <Section className="bg-barber-black relative" data-id="element-319">
      <div className="absolute left-0 top-0 w-1 h-full bg-gradient-to-b from-barber-black via-barber-lightGray to-barber-black opacity-50" data-id="element-320"></div>
      <div className="max-w-3xl mx-auto" data-id="element-321">
        <div className="space-y-8 text-lg md:text-xl text-barber-muted leading-relaxed" data-id="element-322">
          <p className="text-barber-text font-heading text-2xl md:text-3xl tracking-wide" data-id="element-323">
            {t('painStory.line1')}
          </p>
          <p data-id="element-324">{t('painStory.line2')}</p>
          <p data-id="element-325">{t('painStory.line3')}</p>
          <p data-id="element-326">{t('painStory.line4')}</p>
          <p data-id="element-327">{t('painStory.line5')}</p>
          <div className="py-6 my-8 border-y border-barber-lightGray text-center" data-id="element-328">
            <span className="font-heading text-4xl md:text-5xl font-bold text-barber-red tracking-widest" data-id="element-329">
              {t('painStory.closed')}
            </span>
          </div>
          <p className="text-barber-text font-bold" data-id="element-330">{t('painStory.again')}</p>
          <p data-id="element-331">{t('painStory.line6')}</p>
          <blockquote className="border-l-4 border-barber-gold pl-6 py-2 my-8 italic text-barber-text text-xl md:text-2xl font-heading font-light" data-id="element-332">
            {t('painStory.quote')}
          </blockquote>
          <p data-id="element-333">{t('painStory.line7')}</p>
          <ul className="space-y-4 pl-4 text-barber-text" data-id="element-334">
            <li className="flex items-center gap-3" data-id="element-335">
              <span className="w-1.5 h-1.5 rounded-full bg-barber-gold" data-id="element-336"></span>
              {t('painStory.bullet1')}
            </li>
            <li className="flex items-center gap-3" data-id="element-337">
              <span className="w-1.5 h-1.5 rounded-full bg-barber-gold" data-id="element-338"></span>
              {t('painStory.bullet2')}
            </li>
            <li className="flex items-center gap-3" data-id="element-339">
              <span className="w-1.5 h-1.5 rounded-full bg-barber-gold" data-id="element-340"></span>
              {t('painStory.bullet3')}
            </li>
          </ul>
          <p className="pt-6 text-barber-text font-bold text-xl" data-id="element-341">
            {t('painStory.line8')}
          </p>
          <p className="text-barber-gold text-xl md:text-2xl font-heading italic" data-id="element-342">
            {t('painStory.line9')}
          </p>
        </div>
      </div>
    </Section>;
}